import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[resizeListener]'
})
export class ResizeListener {
  @Output() resizeEvent = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    // Emit the resize event when the window is resized
    this.resizeEvent.emit();
  }

  ngAfterViewInit(): void {
    // Use ResizeObserver to detect changes in the size of the element
    const resizeObserver = new (window as any).ResizeObserver(() => {
      this.resizeEvent.emit();
    });

    // Start observing the element for resize changes
    resizeObserver.observe(this.elementRef.nativeElement);
  }
}